import { useState } from "react";
import cssStyles from "./Support.module.scss";

import { useSelector } from "react-redux";
import { Grid2, Rating } from "@mui/material";
import { ReactComponent as FeedbackIcon } from "../../../../GlobalAssets/svg/feedbackicon.svg";
import { ReactComponent as RaiseTicket } from "../../../../GlobalAssets/svg/raiseticket.svg";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import Manage from "../../../../GlobalComponents/WelcomeDashboard/ManageComponent/Manage";
import { links } from "../../../../Utils/docsLinks";
import ModalPopup from "../../../../GlobalComponents/Popup/ModalPopup";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import InputDropdown from "../../../../GlobalComponents/InputDropdown/InputDropdown";

export default function Support() {
  const [isLoading, setIsLoading] = useState(false);
  const [feedbackPopup, setFeedbackPopup] = useState(false);
  const [liveChatTrigger, setLiveChatTrigger] = useState(false);
  const [hover, setHover] = useState(-1);
  const [values, setValues] = useState({
    subject: "",
    subjectState: "error",
    issuesContent: "",
    issuesContentState: "error",
    rating: "",
    ratingState: "error",
    feedbackContent: "",
    feedbackContentState: "error",
    image: "",
  });
  const labels = {
    1: "Poor",
    2: "Fair",
    3: "Average",
    4: "Good",
    5: "Excellent",
  };
  const [errorValues, setErrorValues] = useState({
    subject: false,
    issueContent: false,
    rating: false,
    feedbackContent: false,
  });
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
  });

  let users = useSelector((state) => state.users);

  const handleClosePopup = () => {
    setIsLoading(false);
    setFeedbackPopup(false);
    setValues({
      subject: "",
      subjectState: "error",
      issuesContent: "",
      issuesContentState: "error",
      rating: "",
      ratingState: "error",
      feedbackContent: "",
      feedbackContentState: "error",
      image: "",
    });
    setErrorValues({
      subject: "",
      issueContent: "",
      rating: "",
      feedbackContent: "",
    });
  };

  const submitHandlerFeedback = () => {
    setIsLoading(true);
    if (
      values.ratingState === "error" ||
      values.feedbackContentState === "error"
    ) {
      setErrorValues({
        ...errorValues,
        rating: values.ratingState === "error",
        feedbackContent: values.feedbackContentState === "error",
      });
      return;
    }
    let content = values.feedbackContent;
    let email = users.userInfo?.email;
    let rating = values.rating;
    //let imageUrl = values.image ? presignedUrl.publicUrl : null;
    // const imageUrl = (imageUrl) => {
    //   if (imageUrl.startsWith("blob:")) {
    //     return imageUrl.replace("blob:", "");
    //   }
    //   return imageUrl;
    // };
    // setIsLoading(true);

    getStore().dispatch({
      type: Actions.API_SEND_FEEDBACK,
      data: {
        content: content,
        email: email,
        rating: rating,
        // imageUrl: imageUrl(image),
      },
      meta: {
        onSuccess: () => {
          handleClosePopup();
        },
        onError: () => {
          handleClosePopup();
        },
      },
    });
  };

  function verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  const handleChange = (prop, type, value, length) => {
    let status = "";
    switch (type) {
      case "length":
        if (verifyLength(value, length)) {
          status = "success";
        } else {
          status = "error";
        }
        break;
      default:
        break;
    }
    setValues({
      ...values,
      [prop + "State"]: status,
      [prop]: value,
    });
  };

  const ActivatePopup = (type) => {
    if (type === "lower_env") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "N/A for Lower Enviorments",
        popupSubtitle: "This feature is not available for lower enviorments",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "loading") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Please Wait",
        popupSubtitle: "While we fetch your account details",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "invite_sent") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Invite Sent",
        popupSubtitle:
          "We have sent you an invite to help-center on the registered email",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  const handleOpenPopup = () => {
    setFeedbackPopup(true);
  };

  const triggerLiveChat = () => {
    // Enable the global Rocon chat widget (mounted in App.jsx). The widget
    // listens for this storage flag + custom event, then renders + auto-opens.
    // Persists across page navigations until the user clicks "End chat".
    try {
      localStorage.setItem("rocon_chat_enabled", "true");
      window.dispatchEvent(new Event("rocon-chat-state-change"));
    } catch (_e) {
      // ignore quota/private-mode errors
    }
    setLiveChatTrigger(true);
    // Reset the button's loading state on the next tick; the widget takes over.
    setTimeout(() => setLiveChatTrigger(false), 300);
  };

  const currentLabel = labels[hover] || labels[values.rating];

  const isFeedbackValid =
    values.feedbackContentState === "success" &&
    values.ratingState === "success";

  return (
    <>
      <Grid2 className={cssStyles.header}>Support</Grid2>
      <Grid2 className={cssStyles.mainContainer}>
        <canvas id="curveCanvas" className={cssStyles.canvas}></canvas>
        <Grid2 className={cssStyles.content}>
          <h1>Welcome to Rocon Support</h1>
          <p className={cssStyles.subHeader}>
            We’re here to help. Need personalised assistance or have more
            questions?
          </p>
          <Grid2 className={cssStyles.searchContainer}>
            <InputDropdown
              placeholder="I need help with..."
              options={links}
              className={cssStyles.searchInput}
            />
          </Grid2>
          <Grid2 className={cssStyles.buttonsContainer}>
            <Grid2 className={cssStyles.buttonGap}>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/create-site/",
                    "_blank"
                  )
                }
              >
                Create Your Site
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/manage-site/",
                    "_blank"
                  )
                }
              >
                Manage Your Site
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/staging-environment/",
                    "_blank"
                  )
                }
              >
                Staging Environment
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/create-site/",
                    "_blank"
                  )
                }
              >
                Create Organization
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/create-site/",
                    "_blank"
                  )
                }
              >
                Create Client Organization
              </button>
            </Grid2>
            <Grid2 className={cssStyles.buttonGap}>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/create-site/",
                    "_blank"
                  )
                }
              >
                Blueprint
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/file-explorer/",
                    "_blank"
                  )
                }
              >
                File Explorer
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/add-and-point-your-domain/",
                    "_blank"
                  )
                }
              >
                Add & Point Your Domain
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://docs.roconpaas.io/home/upload-ssl/",
                    "_blank"
                  )
                }
              >
                Enable SSL
              </button>
            </Grid2>
          </Grid2>
          <Grid2
            onClick={() => {
              window.open("https://docs.roconpaas.io/", "blank");
            }}
            className={cssStyles.docsLink}
          >
            Rocon docs
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 className={cssStyles.manageContainer}>
       {/* <Manage
          icon={RaiseTicket}
          header={"Help Center"}
          title={
            "Monitor your support tickets and handle your issues efficiently."
          }
          button={"Track issues "}
          onClick={() => {
            window.open("https://support.roconpaas.com", "blank");
          }}
        />*/}
        {/* <Grid2 className={cssStyles.blurMainContainer}>
          <Grid2 className={cssStyles.star}>
            <StarBorderPurple500OutlinedIcon />
            <Grid2 className={cssStyles.Comingsoon}>Coming soon</Grid2>
          </Grid2>
          <Grid2 className={cssStyles.blurContainer}>
            <Manage
              icon={Migrate}
              header={"Migrate Site For Free"}
              title={
                "Effortlessly move your site to Rocon — we handle everything for free."
              }
              button={"Migrate Now"}
            />
          </Grid2>
        </Grid2> */}

        <Manage
          icon={FeedbackIcon}
          header={"Product Feedback"}
          title={
            "We value your feedback! Tell us how we can improve and make your experience even better. "
          }
          button={"Rate Us"}
          onClick={handleOpenPopup}
        />
      </Grid2>
      <Grid2 className={cssStyles.liveChat}>
        <Grid2>
          <Grid2 className={cssStyles.needHelp}>Need Furthur Assistance?</Grid2>
          <Grid2 className={cssStyles.needHelpSub}>
            Reach out to our support team for person-to-person help 24/7, 365
            days a year.
          </Grid2>
        </Grid2>
        <Grid2>
          {/* Live Chat enables the global Rocon chat widget (mounted in App.jsx). */}
          <CustomButton onClick={triggerLiveChat} loading={liveChatTrigger}>
            Live Chat
          </CustomButton>
        </Grid2>
      </Grid2>
      <ModalPopup
        trigger={feedbackPopup}
        header={"Product Feedback"}
        closePopup={handleClosePopup}
        backPopup={"Cancel"}
        backOnClick={handleClosePopup}
        nextpopup={"Submit"}
        nextOnClick={submitHandlerFeedback}
        loading={isLoading}
        disabled={!isFeedbackValid}
      >
        <Grid2 item className={cssStyles.feedbackInput}>
          <CustomInput
            title={"How can we improve?"}
            placeholder={"Please share your feedback"}
            value={values.feedbackContent}
            error={errorValues.feedbackContent}
            setValue={(value) => {
              handleChange("feedbackContent", "length", value, 3);
            }}
          />
        </Grid2>
        <Grid2 item className={cssStyles.rating}>
          <Rating
            name="size-large"
            size="large"
            value={values.rating}
            sx={{
              fontSize: "28px",
              "& .MuiRating-iconEmpty": {
                color: users?.userDetails?.theme === "dark" ? "#fff" : "#000",
              },
            }}
            onChange={(_, value) => {
              setValues({ ...values, rating: value, ratingState: "success" });
            }}
            onChangeActive={(_, newHover) => {
              setHover(newHover);
            }}
          />

          <Grid2 className={cssStyles.ratingColor}>
            Your Rating{currentLabel && `: ${currentLabel}`}
          </Grid2>

          {/* Commenting the below code as file upload is not relavent in feedback. this can be reused if we enable issues tab later in future*/}
          {/* <Grid2 item>
            <div className={cssStyles.textContainer}>
              {!image && (
                <>
                  <label
                    htmlFor="file-upload"
                    className={cssStyles.uploadContainer}
                  >
                    <span className={cssStyles.uploadfile}>Upload File</span>
                    <div className={cssStyles.uploadfile1}>
                      <UploadIcon />
                    </div>
                  </label>
                </>
              )}

              <input
                id="file-upload"
                style={{ display: "none" }}
                type="file"
                onChange={(e) => {
                  const [file] = e.target.files;
                  if (!file) return;

                  const maxSize = 2 * 1024 * 1024;
                  if (file.size > maxSize) {
                    setImageError("File size must be 2MB or less.");
                    e.target.value = "";
                    return;
                  }

                  setValues({ ...values, image: file });
                  setImg(URL.createObjectURL(file));
                  setImageName(file.name);
                  setImageError("");
                  setImageSize(formatFileSize(file.size));
                  fileInputRef.current.value = "";
                }}
                accept="image/png, image/gif, image/jpeg"
                ref={fileInputRef}
              />

              <div style={{ position: "relative" }}>
                {image && values.image && (
                  <div className={cssStyles.imgNameSizeContainer}>
                    <div className={cssStyles.imgNameSize}>
                      <span className={cssStyles.imgName}>{imageName}</span>
                      <span>{imageSize}</span>
                    </div>
                    {image && values.image && (
                      <div
                        className={cssStyles.uploadfile2}
                        onClick={() => {
                          resetImageState();
                        }}
                      >
                        <DeleteIcon />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Grid2> */}
        </Grid2>
      </ModalPopup>
    </>
  );
}
